exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1oCA7LfBUQztOaYgf9z_BR{position:relative;display:block;width:100%;max-height:700px;text-align:center}._1oCA7LfBUQztOaYgf9z_BR iframe{position:absolute;width:100%;height:100%;top:0;left:0;right:0;bottom:0}\n", ""]);

// Exports
exports.locals = {
	"EmbedBlock": "_1oCA7LfBUQztOaYgf9z_BR"
};